export const validMaxSizeM = (file: File, sizeM: number) => {
  if (!file) { return true }

  const max = sizeM * 1024 * 1024
 
  return file.size < max
}